"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Any = void 0;
var _runtime = require("@protobuf-ts/runtime");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } // @generated by protobuf-ts 2.8.2 with parameter long_type_number,keep_enum_prefix,generate_dependencies
// @generated from protobuf file "google/protobuf/any.proto" (package "google.protobuf", syntax proto3)
// tslint:disable
//
// Protocol Buffers - Google's data interchange format
// Copyright 2008 Google Inc.  All rights reserved.
// https://developers.google.com/protocol-buffers/
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are
// met:
//
//     * Redistributions of source code must retain the above copyright
// notice, this list of conditions and the following disclaimer.
//     * Redistributions in binary form must reproduce the above
// copyright notice, this list of conditions and the following disclaimer
// in the documentation and/or other materials provided with the
// distribution.
//     * Neither the name of Google Inc. nor the names of its
// contributors may be used to endorse or promote products derived from
// this software without specific prior written permission.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
/**
 * `Any` contains an arbitrary serialized protocol buffer message along with a
 * URL that describes the type of the serialized message.
 *
 * Protobuf library provides support to pack/unpack Any values in the form
 * of utility functions or additional generated methods of the Any type.
 *
 * Example 1: Pack and unpack a message in C++.
 *
 *     Foo foo = ...;
 *     Any any;
 *     any.PackFrom(foo);
 *     ...
 *     if (any.UnpackTo(&foo)) {
 *       ...
 *     }
 *
 * Example 2: Pack and unpack a message in Java.
 *
 *     Foo foo = ...;
 *     Any any = Any.pack(foo);
 *     ...
 *     if (any.is(Foo.class)) {
 *       foo = any.unpack(Foo.class);
 *     }
 *
 * Example 3: Pack and unpack a message in Python.
 *
 *     foo = Foo(...)
 *     any = Any()
 *     any.Pack(foo)
 *     ...
 *     if any.Is(Foo.DESCRIPTOR):
 *       any.Unpack(foo)
 *       ...
 *
 * Example 4: Pack and unpack a message in Go
 *
 *      foo := &pb.Foo{...}
 *      any, err := anypb.New(foo)
 *      if err != nil {
 *        ...
 *      }
 *      ...
 *      foo := &pb.Foo{}
 *      if err := any.UnmarshalTo(foo); err != nil {
 *        ...
 *      }
 *
 * The pack methods provided by protobuf library will by default use
 * 'type.googleapis.com/full.type.name' as the type URL and the unpack
 * methods only use the fully qualified type name after the last '/'
 * in the type URL, for example "foo.bar.com/x/y.z" will yield type
 * name "y.z".
 *
 *
 * JSON
 *
 * The JSON representation of an `Any` value uses the regular
 * representation of the deserialized, embedded message, with an
 * additional field `@type` which contains the type URL. Example:
 *
 *     package google.profile;
 *     message Person {
 *       string first_name = 1;
 *       string last_name = 2;
 *     }
 *
 *     {
 *       "@type": "type.googleapis.com/google.profile.Person",
 *       "firstName": <string>,
 *       "lastName": <string>
 *     }
 *
 * If the embedded message type is well-known and has a custom JSON
 * representation, that representation will be embedded adding a field
 * `value` which holds the custom JSON in addition to the `@type`
 * field. Example (for message [google.protobuf.Duration][]):
 *
 *     {
 *       "@type": "type.googleapis.com/google.protobuf.Duration",
 *       "value": "1.212s"
 *     }
 *
 *
 * @generated from protobuf message google.protobuf.Any
 */
// @generated message type with reflection information, may provide speed optimized methods
var Any$Type = /*#__PURE__*/function (_MessageType) {
  function Any$Type() {
    _classCallCheck(this, Any$Type);
    return _callSuper(this, Any$Type, ["google.protobuf.Any", [{
      no: 1,
      name: "type_url",
      kind: "scalar",
      T: 9 /*ScalarType.STRING*/
    }, {
      no: 2,
      name: "value",
      kind: "scalar",
      T: 12 /*ScalarType.BYTES*/
    }]]);
  }
  /**
   * Pack the message into a new `Any`.
   *
   * Uses 'type.googleapis.com/full.type.name' as the type URL.
   */
  _inherits(Any$Type, _MessageType);
  return _createClass(Any$Type, [{
    key: "pack",
    value: function pack(message, type) {
      return {
        typeUrl: this.typeNameToUrl(type.typeName),
        value: type.toBinary(message)
      };
    }
    /**
     * Unpack the message from the `Any`.
     */
  }, {
    key: "unpack",
    value: function unpack(any, type, options) {
      if (!this.contains(any, type)) throw new Error("Cannot unpack google.protobuf.Any with typeUrl '" + any.typeUrl + "' as " + type.typeName + ".");
      return type.fromBinary(any.value, options);
    }
    /**
     * Does the given `Any` contain a packed message of the given type?
     */
  }, {
    key: "contains",
    value: function contains(any, type) {
      if (!any.typeUrl.length) return false;
      var wants = typeof type == "string" ? type : type.typeName;
      var has = this.typeUrlToName(any.typeUrl);
      return wants === has;
    }
    /**
     * Convert the message to canonical JSON value.
     *
     * You have to provide the `typeRegistry` option so that the
     * packed message can be converted to JSON.
     *
     * The `typeRegistry` option is also required to read
     * `google.protobuf.Any` from JSON format.
     */
  }, {
    key: "internalJsonWrite",
    value: function internalJsonWrite(any, options) {
      var _opt$typeRegistry;
      if (any.typeUrl === "") return {};
      var typeName = this.typeUrlToName(any.typeUrl);
      var opt = (0, _runtime.jsonWriteOptions)(options);
      var type = (_opt$typeRegistry = opt.typeRegistry) === null || _opt$typeRegistry === void 0 ? void 0 : _opt$typeRegistry.find(function (t) {
        return t.typeName === typeName;
      });
      if (!type) throw new globalThis.Error("Unable to convert google.protobuf.Any with typeUrl '" + any.typeUrl + "' to JSON. The specified type " + typeName + " is not available in the type registry.");
      var value = type.fromBinary(any.value, {
        readUnknownField: false
      });
      var json = type.internalJsonWrite(value, opt);
      if (typeName.startsWith("google.protobuf.") || !(0, _runtime.isJsonObject)(json)) json = {
        value: json
      };
      json["@type"] = any.typeUrl;
      return json;
    }
  }, {
    key: "internalJsonRead",
    value: function internalJsonRead(json, options, target) {
      var _options$typeRegistry;
      if (!(0, _runtime.isJsonObject)(json)) throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON " + (0, _runtime.typeofJsonValue)(json) + ".");
      if (typeof json["@type"] != "string" || json["@type"] == "") return this.create();
      var typeName = this.typeUrlToName(json["@type"]);
      var type = options === null || options === void 0 || (_options$typeRegistry = options.typeRegistry) === null || _options$typeRegistry === void 0 ? void 0 : _options$typeRegistry.find(function (t) {
        return t.typeName == typeName;
      });
      if (!type) throw new globalThis.Error("Unable to parse google.protobuf.Any from JSON. The specified type " + typeName + " is not available in the type registry.");
      var value;
      if (typeName.startsWith("google.protobuf.") && json.hasOwnProperty("value")) value = type.fromJson(json["value"], options);else {
        var copy = Object.assign({}, json);
        delete copy["@type"];
        value = type.fromJson(copy, options);
      }
      if (target === undefined) target = this.create();
      target.typeUrl = json["@type"];
      target.value = type.toBinary(value);
      return target;
    }
  }, {
    key: "typeNameToUrl",
    value: function typeNameToUrl(name) {
      if (!name.length) throw new Error("invalid type name: " + name);
      return "type.googleapis.com/" + name;
    }
  }, {
    key: "typeUrlToName",
    value: function typeUrlToName(url) {
      if (!url.length) throw new Error("invalid type url: " + url);
      var slash = url.lastIndexOf("/");
      var name = slash > 0 ? url.substring(slash + 1) : url;
      if (!name.length) throw new Error("invalid type url: " + url);
      return name;
    }
  }, {
    key: "create",
    value: function create(value) {
      var message = {
        typeUrl: "",
        value: new Uint8Array(0)
      };
      globalThis.Object.defineProperty(message, _runtime.MESSAGE_TYPE, {
        enumerable: false,
        value: this
      });
      if (value !== undefined) (0, _runtime.reflectionMergePartial)(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
        end = reader.pos + length;
      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
          _reader$tag2 = _slicedToArray(_reader$tag, 2),
          fieldNo = _reader$tag2[0],
          wireType = _reader$tag2[1];
        switch (fieldNo) {
          case /* string type_url */1:
            message.typeUrl = reader.string();
            break;
          case /* bytes value */2:
            message.value = reader.bytes();
            break;
          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? _runtime.UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }
      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string type_url = 1; */
      if (message.typeUrl !== "") writer.tag(1, _runtime.WireType.LengthDelimited).string(message.typeUrl);
      /* bytes value = 2; */
      if (message.value.length) writer.tag(2, _runtime.WireType.LengthDelimited).bytes(message.value);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? _runtime.UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);
}(_runtime.MessageType);
/**
 * @generated MessageType for protobuf message google.protobuf.Any
 */
var Any = exports.Any = new Any$Type();